import Icon from 'components/Icon'
import { EtsyIcon } from 'components/Icon/icons/etsy.js'
import { FacebookIcon } from 'components/Icon/icons/facebook'
import { GoogleIcon } from 'components/Icon/icons/google'
import { InstagramIcon } from 'components/Icon/icons/instagram'
import { PinterestIcon } from 'components/Icon/icons/pinterest'
import { TumblrIcon } from 'components/Icon/icons/tumblr'
import { SOCIAL_NAME } from 'constants/social'
import PropTypes from 'prop-types'
import React from 'react'
import XIcon from 'components/Icon/icons/x'

const NAME_TO_ICON = {
  [SOCIAL_NAME.ETSY]: EtsyIcon,
  [SOCIAL_NAME.FACEBOOK]: FacebookIcon,
  [SOCIAL_NAME.INSTAGRAM]: InstagramIcon,
  [SOCIAL_NAME.GOOGLE]: GoogleIcon,
  [SOCIAL_NAME.TUMBLR]: TumblrIcon,
  [SOCIAL_NAME.X]: XIcon,
  [SOCIAL_NAME.PINTEREST]: PinterestIcon
}

function SocialIcon ({ name }) {
  return (
    <div className='socialIcon'>
      <Icon
        icon={NAME_TO_ICON[name]}
        size={Icon.SIZE.MEDIUM}
      />
    </div>
  )
}

SocialIcon.propTypes = {
  name: PropTypes.string.isRequired
}

export default SocialIcon
